import breakpoints from 'library/styles/vars/breakpoints.json'

export default
	data: ->
		breakpoints:
			# These will stay up to date
			isDesktopUp: false
			isTabletLandscapeUp: false
			isTabletUp: false
			isMobileLandscapeUp: false
			isMobileUp: false

	mounted: ->
		@setupBreakpointWatcher()

	methods:
		setupBreakpointWatcher: ->
			# Setup MediaQueryLists
			mqDesktopUp =           matchMedia "(min-width: #{breakpoints['desktop']})"
			mqTabletLandscapeUp =   matchMedia "(min-width: #{breakpoints['tablet-landscape']})"
			mqTabletUp =            matchMedia "(min-width: #{breakpoints['tablet']})"
			mqMobileLandscapeUp =   matchMedia "(min-width: #{breakpoints['mobile-landscape']})"
			mqMobileUp =            matchMedia "(min-width: #{breakpoints['mobile']})"

			# Set initial values
			@breakpoints.isDesktopUp = mqDesktopUp.matches
			@breakpoints.isTabletLandscapeUp = mqTabletLandscapeUp.matches
			@breakpoints.isTabletUp = mqTabletUp.matches
			@breakpoints.isMobileLandscapeUp = mqMobileLandscapeUp.matches
			@breakpoints.isMobileUp = mqMobileUp.matches

			# Watch for changes
			mqDesktopUp.onchange =         (e) => @breakpoints.isDesktopUp = e.matches
			mqTabletLandscapeUp.onchange = (e) => @breakpoints.isTabletLandscapeUp = e.matches
			mqTabletUp.onchange =          (e) => @breakpoints.isTabletUp = e.matches
			mqMobileLandscapeUp.onchange = (e) => @breakpoints.isMobileLandscapeUp = e.matches
			mqMobileUp.onchange =          (e) => @breakpoints.isMobileUp = e.matches

